export class LabelKeys {
  static readonly errors = {
    ISE: 'ISE',
    BRE: 'BRE',
    UAT: 'UAT',
    FOR: 'FOR',
    NFE: 'NFE',
  };

  static readonly metadata = {
    applicationId: 'metadata.applicationId',
    applicationName: 'metadata.applicationName',
    user: 'metadata.user',
  };

  static readonly popMessages = {
    error: {
      failedOtpValidation: 'popMessages.error.failedOtpValidation',
      failedToLoadForm: 'popMessages.error.failedToLoadForm',
      failedToParseForm: 'popMessages.error.failedToParseForm',
      failedToSaveForm: 'popMessages.error.failedToSaveForm',
      failedToPublishDictionary: 'popMessages.error.failedToPublishDictionary',
      failedToLoadDictionary: 'popMessages.error.failedToLoadDictionary',
      failedValidation: 'popMessages.error.failedValidation',
      partnerFailed: 'popMessages.error.partnerFailed',
      documentFailed: 'popMessages.error.documentFailed',
      documentWithSameNameAlreadyAdded:
        'popMessages.error.documentWithSameNameAlreadyAdded',
      mappingFailed: 'popMessages.error.mappingFailed',
      invalidValues: 'popMessages.error.invalidValues',
      atLeastOneValue: 'popMessages.error.atLeastOneValue',
      atLeastOneDependentValue:
        'popMessages.error.failedNeedToSetAtLeastOneDependentValue',
      atLeastOneLanguage: 'popMessages.error.atLeastOneLanguage',
      mustSelectImageFormat: 'popMessages.error.mustSelectImageFormat',
      cannotDeleteDocWithVersions:
        'popMessages.error.cannotDeleteDocWithVersions',
      cannotDeleteUsedDocs: 'popMessages.error.cannotDeleteUsedDocs',
      cannotDeleteKycWithQualifiedSign:
        'popMessages.error.cannotDeleteKycWithQualifiedSign',
      mustSelectDocFile: 'popMessages.error.mustSelectDocFile',
      insertValidFrom: 'popMessages.error.insertValidFrom',
      validFromOlderThan: 'popMessages.error.validFromOlderThan',
      validDateGreaterThan: 'popMessages.error.validDateGreaterThan',
      insertVersion: 'popMessages.error.insertVersion',
      insertName: 'popMessages.error.insertName',
      documentWithSameVersion: 'popMessages.error.documentWithSameVersion',
      documentVersionCannotBeLower:
        'popMessages.error.documentVersionCannotBeLower',
      versionCannotBeDeleted: 'popMessages.error.versionCannotBeDeleted',
      saveAppBeforeAddingDoc: 'popMessages.error.saveAppBeforeAddingDoc',
      needToCompleteVersionEdit: 'popMessages.error.needToCompleteVersionEdit',
      selectedPartnerAlreadyAdded:
        'popMessages.error.selectedPartnerAlreadyAdded',
      selectedMethodAlreadyAdded:
        'popMessages.error.selectedMethodAlreadyAdded',
      selectedDocumentAlreadyAdded:
        'popMessages.error.selectedDocumentAlreadyAdded',
      completeCurrentMappingFirst:
        'popMessages.error.completeCurrentMappingFirst',
      selectApiMethod: 'popMessages.error.selectApiMethod',
      publishFail: 'popMessages.error.publishFail',
      selectMethodBeforeAdding: 'popMessages.error.selectMethodBeforeAdding',
      noStatusesAvailableToClean:
        'popMessages.error.noStatusesAvailableToClean',
      dictionaryCannotBeDeleted: 'popMessages.error.dictionaryCannotBeDeleted',
      partnerUsedInActionStep: 'popMessages.error.partnerUsedInActionStep',
      methodCannotBeDeleted: 'popMessages.error.methodCannotBeDeleted',
      noDocumentsGeneratedStep: 'popMessages.error.noDocumentsGeneratedStep',
      invalidWorkflowFileFormat: 'popMessages.error.invalidWorkflowFileFormat',
      invalidWorkflowFileStruct: 'popMessages.error.invalidWorkflowFileStruct',
      errorReadingWorkflowFile: 'popMessages.error.errorReadingWorkflowFile',
    },
    success: {
      dictionarySaved: 'popMessages.success.dictionarySaved',
      succesfullyOtpValidation: 'popMessages.success.succesfullyOtpValidation',
      formSaved: 'popMessages.success.formSaved',
      partnerSuccesfulyAdded: 'popMessages.success.partnerSuccesfulyAdded',
      partnerSuccesfulyDeleted: 'popMessages.success.partnerSuccesfulyDeleted',
      publishSuccess: 'popMessages.success.publishSuccess',
      dictionarySuccesfulyDeleted:
        'popMessages.success.dictionarySuccesfulyDeleted',
      posSuccesfulyDeleted: 'point-of-sales.deleted',
      posSuccesfulyCreated: 'point-of-sales.created',
      workflowImportedSuccesfully: '',
    },
  };

  static readonly validatorMessages = {
    applicationNameRequired: 'validatorMessages.applicationNameRequired',
    applicationTypeRequired: 'validatorMessages.applicationTypeRequired',
    applicationLanguageRequired:
      'validatorMessages.applicationLanguageRequired',
    applicationDefaultLanguageRequired:
      'validatorMessages.applicationDefaultLanguageRequired',
    sectionTranslationRequired: 'validatorMessages.sectionTranslationRequired',
    sectionTitleRequired: 'validatorMessages.sectionTitleRequired',
    duplicateSectionTitleFound: 'validatorMessages.duplicateSectionTitleFound',
    stepNameIsRequired: 'validatorMessages.stepNameIsRequired',
    duplicateStepNameFound: 'validatorMessages.duplicateStepNameFound',
    allTranslationsMustHaveValues:
      'validatorMessages.allTranslationsMustHaveValues',
    controlTitleIsRequired: 'validatorMessages.controlTitleIsRequired',
    allControlTranslationsMustHaveValues:
      'validatorMessages.allControlTranslationsMustHaveValues',
    controlTranslationsAreRequired:
      'validatorMessages.controlTranslationsAreRequired',
    controlMaxChars: 'validatorMessages.controlMaxChars',
    duplicateControlTitleFound: 'validatorMessages.duplicateControlTitleFound',
    getMethodMustHaveName: 'validatorMessages.getMethodMustHaveName',
    sendMethodMustHaveName: 'validatorMessages.sendMethodMustHaveName',
    selectADictionary: 'validatorMessages.selectADictionary',
    methodMustHaveAName: 'validatorMessages.methodMustHaveAName',
    applicationMappingRequired: 'validatorMessages.applicationMappingRequired',
    missingDocuments: 'validatorMessages.missingDocuments',
    dictionaryMappingMissing: 'validatorMessages.dictionaryMappingMissing',
    dictionaryLanguageNotInApplication:
      'validatorMessages.dictionaryLanguageNotInApplication',
    duplicateDocumentId: 'validatorMessages.duplicateDocumentId',
    documentIdRequired: 'validatorMessages.documentIdRequired',
    requiredField: 'validatorMessages.requiredField',
    invalidUrl: 'validatorMessages.invalidUrl',
    invalidFormat: 'validatorMessages.invalidFormat',
    minValue: 'validatorMessages.minValue',
  };

  static readonly confirmDialog = {
    partnerBody: {
      title: 'confirmDialog.partnerBody.title',
    },
    partnerMethodApi: {
      title: 'confirmDialog.partnerMethodApi.title',
    },
    regenerateApiKey: {
      title: 'confirmDialog.regenerateApiKey.title',
      message: 'confirmDialog.regenerateApiKey.message',
    },
    common: {
      warningMessage: 'confirmDialog.common.warningMessage',
    },
    dialogButtons: {
      cancel: 'confirmDialog.dialogButtons.cancel',
      confirm: 'confirmDialog.dialogButtons.confirm',
    },
  };

  static readonly unsavedChanges = {
    title: 'unsavedChanges.title',
    message: 'unsavedChanges.message',
    discard: 'unsavedChanges.discard',
    stayOnPage: 'unsavedChanges.stayOnPage',
  };

  static readonly placeholders = {
    name: 'placeholders.name',
    choose: 'placeholders.choose',
    chooseLanguage: 'placeholders.chooseLanguage',
    chooseDocuments: 'placeholders.chooseDocuments',
    noDocuments: 'placeholders.noDocuments',
    version: 'placeholders.version',
    keyName: 'placeholders.keyName',
    apiKey: 'placeholders.apiKey',
    headerKey: 'placeholders.headerKey',
    headerValue: 'placeholders.headerValue',
    valability: 'placeholders.valability',
    partnerField: 'placeholder.partnerField',
    noPartners: 'placeholders.noPartners',
    enterStepName: 'placeholder.enterStepName',
    email: 'placeholders.email',
    password: 'placeholders.password',
    none: 'placeholders.none',
    translation: 'placeholders.translation',
  };
  static readonly netopia = {
    amount: 'flux.netopia.amount',
    merchantId: 'flux.netopia.merchantId',
    clientId: 'flux.netopia.clientId',
    manualInput: 'flux.netopia.manualInput',
    currency: 'flux.netopia.currency',
    cardHolderId: 'flux.netopia.cardHolderId',
    description: 'common.others.description',
    valability: 'placeholders.valability',
    firstName: 'flux.netopia.firstName',
    lastName: 'flux.netopia.lastName',
    mobilePhone: 'flux.netopia.mobilePhone',
  };
  static readonly common = {
    form: {
      email: 'common.form.email',
      cancel: 'common.form.cancel',
    },
    actions: {
      copy: 'common.actions.copy',
      read: 'common.actions.read',
      create: 'common.actions.create',
      write: 'common.actions.write',
      view: 'common.actions.view',
      filter: 'common.actions.filter',
      includeInactive: 'common.actions.includeInactive',
      save: 'common.actions.save',
      confirm: 'common.actions.confirm',
      cancel: 'common.actions.cancel',
      back: 'common.actions.back',
      next: 'common.actions.next',
      submit: 'common.actions.submit',
      close: 'common.actions.close',
      add: 'common.actions.add',
      addValue: 'common.actions.addValue',
      edit: 'common.actions.edit',
      delete: 'common.actions.delete',
      check: 'common.actions.check',
      import: 'common.actions.import',
      export: 'common.actions.export',
      collapseAll: 'common.actions.collapse-all',
      logout: 'common.actions.logout',
      upload: 'common.actions.upload',
      expand: 'common.actions.expand',
      collapse: 'common.actions.collapse',
      loadMore: 'common.actions.loadMore',
      exportConfiguration: 'common.actions.exportConfiguration',
      importConfiguration: 'common.actions.importConfiguration',
    },
    pagination: {
      noItems: 'common.pagination.noItems',
      perPage: 'common.pagination.perPage',
      of: 'common.pagination.of',
    },
    confirmation: {
      title: 'common.confirmation.title',
      delete: 'common.confirmation.delete',
    },
    api: {
      addMethod: 'common.api.addMethod',
      addField: 'common.api.addField',
    },
    components: {
      button: 'common.components.button',
    },
    others: {
      translation: 'common.others.translation',
      type: 'common.others.type',
      active: 'common.others.active',
      newItem: 'common.others.newItem',
      name: 'common.others.name',
      code: 'common.others.code',
      notifications: 'common.others.notifications',
      seeAllNotifications: 'common.others.seeAllNotifications',
      viewProfile: 'common.others.viewProfile',
      description: 'common.others.description',
      adress: 'common.others.adress',
      yes: 'common.others.yes',
      no: 'common.others.no',
      buttonSelection: 'common.others.buttonSelection',
      selectedButtonsTranslations: 'common.others.selectedButtonsTranslations',
      loadingControls: 'common.others.loadingControls',
    },
    selects: {
      select: 'common.selects.select',
      none: 'common.selects.none',
    },
  };

  static readonly login = {
    form: {
      title: 'login.form.authentication-title',
      emailValidation: 'login.form.email-validation',
      password: 'login.form.password',
      passwordValidation: 'login.form.password-validation',
      submit: 'login.form.submit',
      passwordResetButton: 'login.form.password-reset',
      stayLoggedIn: 'login.form.stay-logged-in',
    },
    reset: {
      emailSent: 'login.reset.emailSent',
      passwordUpdated: 'login.reset.passwordUpdated',
    },
  };

  static readonly register = {
    form: {
      title: 'register.form.register-title',
      poses: 'register.form.assigned-pos-list',
      role: 'register.form.role',
      submit: 'register.form.submit',
      successMessage: 'register.form.successMessage',
      errors: {
        emailRequired: 'register.form.errors.emailRequired',
        emailInvalid: 'register.form.errors.emailInvalid',
        roleRequired: 'register.form.errors.roleRequired',
      },
    },
  };

  static readonly cardEnrolKeys = {
    failure: 'cardenrol.failure',
    success: 'cardenrol.success',
  };

  static readonly roles = {
    title: 'role.title',
    viewButton: 'role.viewButton',
    editButton: 'role.editButton',
    createButton: 'role.createButton',
    view: {
      title: 'role.view.title',
    },
    edit: {
      title: 'role.edit.title',
      successMessage: 'role.edit.successMessage',
    },
    create: {
      successMessage: 'role.create.successMessage',
    },
    form: {
      title: 'role.form.title',
      name: 'role.form.name',
      permissions: 'role.form.permissions',
      submit: 'role.form.submit',
    },
  };

  static readonly profile = {
    title: 'profile.title',
    view: {
      title: 'profile.view.title',
      edit: 'profile.view.edit',
      name: 'profile.view.name',
      email: 'profile.view.email',
      phone: 'profile.view.phone',
      address: 'profile.view.address',
    },
    edit: {
      title: 'profile.edit.title',
      personal: {
        title: 'profile.edit.personal.title',
        browse: 'profile.edit.personal.browse',
        name: 'profile.edit.personal.name',
        namePlaceholder: 'profile.edit.personal.namePlaceholder',
        email: 'profile.edit.personal.email',
        emailPlaceholder: 'profile.edit.personal.emailPlaceholder',
        phone: 'profile.edit.personal.phone',
        phonePlaceholder: 'profile.edit.personal.phonePlaceholder',
        address: 'profile.edit.personal.address',
        addressPlaceholder: 'profile.edit.personal.addressPlaceholder',
      },
      password: {
        title: 'profile.edit.password.title',
        current: 'profile.edit.password.current',
        currentPlaceholder: 'profile.edit.password.currentPlaceholder',
        password: 'profile.edit.password.password',
        passwordPlaceholder: 'profile.edit.password.passwordPlaceholder',
        confirm: 'profile.edit.password.confirm',
        confirmPlaceholder: 'profile.edit.password.confirmPlaceholder',
      },
      save: 'profile.edit.save',
      cancel: 'profile.edit.cancel',
      successMessage: 'profile.edit.successMessage',
      errors: {
        selectImage: 'profile.edit.errors.selectImage',
        imageOnly: 'profile.edit.errors.imageOnly',
        currentPassword: 'profile.edit.errors.currentPassword',
        newPassword: 'profile.edit.errors.newPassword',
        passwordConfirmation: 'profile.edit.errors.passwordConfirmation',
        passwordsUnmatch: 'profile.edit.errors.passwordsUnmatch',
      },
    },
  };

  static readonly users = {
    title: 'users.title',
    grid: {
      create: 'users.grid.create',
      email: 'users.grid.email',
      name: 'users.grid.name',
      role: 'users.grid.role',
      active: 'users.grid.active',
      blocked: 'users.grid.blocked',
    },
    view: {
      title: 'users.view.title',
      id: 'users.view.id',
      phone: 'users.view.phone',
      address: 'users.view.address',
      profile: {
        title: 'users.view.profile.title',
        email: 'users.view.profile.email',
        emailPlaceholder: 'users.view.profile.emailPlaceholder',
        role: 'users.view.profile.role',
        rolePlaceholder: 'users.view.profile.rolePlaceholder',
        pos: 'users.view.profile.pos',
        posPlaceholder: 'users.view.profile.posPlaceholder',
        active: 'users.view.profile.active',
        blocked: 'users.view.profile.blocked',
        update: 'users.view.profile.update',
        successMessage: 'users.view.profile.successMessage',
      },
      sessions: {
        title: 'users.view.sessions.title',
        device: 'users.view.sessions.device',
        os: 'users.view.sessions.os',
        ip: 'users.view.sessions.ip',
        browser: 'users.view.sessions.browser',
        date: 'users.view.sessions.date',
      },
      logs: {
        title: 'users.view.logs.title',
        action: 'users.view.logs.action',
        status: 'users.view.logs.status',
        path: 'users.view.logs.path',
        date: 'users.view.logs.date',
      },
    },
  };

  static readonly dictionary = {
    title: 'dictionary.title',
    grid: {
      create: 'dictionary.grid.create',
      name: 'dictionary.grid.name',
      languages: 'dictionary.grid.languages',
      state: 'dictionary.grid.state',
      dictionaryName: 'dictionary.grid.dictionaryName',
      showInForm: 'dictionary.grid.showInForm',
      translations: 'dictionary.grid.translations',
    },
    deleteSuccess: 'dictionary.deleteSuccess',
    errors: {
      undeletable: 'dictionary.errors.undeletable',
      resetValues: 'dictionary.errors.resetValues',
      noDictionaryComponentDefined:
        'dictionary.errors.noDictionaryComponentDefined',
      atLeastOneValue: 'dictionary.errors.atLeastOneValue',
      atLeastOneLanguage: 'dictionary.errors.atLeastOneLanguage',
      invalidValues: 'dictionary.errors.invalidValues',
      atLeastOneDependentValue: 'dictionary.errors.atLeastOneDependentValue',
      noValuesFound: 'dictionary.errors.noValuesFound',
    },
    others: {
      dictionaryValues: 'dictionary.others.dictionaryValues',
      dependentDictionary: 'dictionary.others.dependentDictionary',
      sourceDictionaries: 'dictionary.others.sourceDictionaries',
      active: 'dictionary.others.active',
      versions: 'dictionary.others.versions',
      default: 'dictionary.others.default',
    },
  };

  static readonly applicationType = {
    saved: 'applicationType.saved',
    deleted: 'applicationType.deleted',
  };

  static readonly applications = {
    title: 'applications.title',
    newApplication: 'applications.newApplication',
    create: 'applications.create',
    edit: 'applications.edit',
    grid: {
      create: 'applications.grid.create',
      name: 'applications.grid.name',
      date: 'applications.grid.date',
      duplicate: 'applications.grid.duplicate',
    },
    deleteSuccess: 'applications.deleteSuccess',
    duplicateSuccess: 'applications.duplicateSuccess',
    duplicate: {
      confirmTitle: 'applications.duplicate.confirmTitle',
      confirmMessage: 'applications.duplicate.confirmMessage',
    },
    errors: {
      undeletable: 'applications.errors.undeletable',
    },
    noDataAvailableForSelectedType:
      'applications.noDataAvailableForSelectedType',
  };
  static readonly notifications = {
    title: 'notifications.title',
    newBadge: 'notifications.newBadge',
    noNotifications: 'notifications.noNotifications',
    seeAll: 'notifications.seeAll',
    markAllAsRead: 'notifications.markAllAsRead',
    noNotificationsYet: 'notifications.noNotificationsYet',
  };

  static readonly childApplications = {
    title: 'childApplications.title',
    noChildApplicationsFound: 'childApplications.noChildApplicationsFound',
    application: 'childApplications.application',
    status: 'childApplications.status',
    created: 'childApplications.created',
    actions: 'childApplications.actions',
    view: 'childApplications.view',
    children: 'childApplications.children',
    launchChild: 'childApplications.launchChild',
    pendingChildLaunches: 'childApplications.pendingChildLaunches',
    noPendingChildren: 'childApplications.noPendingChildren',
  };

  static readonly launchChildDialog = {
    title: 'launchChildDialog.title',
    noAppsAvailable: 'launchChildDialog.noAppsAvailable',
    selectChildApplication: 'launchChildDialog.selectChildApplication',
    launch: 'launchChildDialog.launch',
  };

  static readonly parentChildConfig = {
    title: 'parentChildConfig.title',
    parentApplication: 'parentChildConfig.parentApplication',
    none: 'parentChildConfig.none',
    inheritedFields: 'parentChildConfig.inheritedFields',
    enableNotifications: 'parentChildConfig.enableNotifications',
    notificationTitle: 'parentChildConfig.notificationTitle',
    notificationMessage: 'parentChildConfig.notificationMessage',
    hasChildrenWarning: 'parentChildConfig.hasChildrenWarning',
  };

  static readonly contactMethodConfig = {
    title: 'contactMethodConfig.title',
    emailField: 'contactMethodConfig.emailField',
    phoneField: 'contactMethodConfig.phoneField',
    preferredMethod: 'contactMethodConfig.preferredMethod',
    continuationBaseUrl: 'contactMethodConfig.continuationBaseUrl',
    none: 'contactMethodConfig.none',
  };

  static readonly appConfigEdit = {
    history: {
      name: 'appConfigEdit.name',
      user: 'appConfigEdit.history.user',
      dateModified: 'appConfigEdit.history.dateModified',
      summary: 'appConfigEdit.history.summary',
    },
    generalData: {
      name: 'appConfigEdit.generalData.name',
      appType: 'appConfigEdit.generalData.appType',
      languages: 'appConfigEdit.generalData.languages',
      defaultLanguage: 'appConfigEdit.generalData.defaultLanguage',
      contentWithOffer: 'appConfigEdit.generalData.contentWithOffer',
      showCounterStep: 'appConfigEdit.generalData.showCounterStep',
      showNameStep: 'appConfigEdit.generalData.showNameStep',
      showAllSteps: 'appConfigEdit.generalData.showAllSteps',
      showProgressBar: 'appConfigEdit.generalData.showProgressBar',
      initFlowValues: 'appConfigEdit.generalData.initFlowValues',
      getTestVersion: 'appConfigEdit.generalData.getTestVersion',
      publishOnTest: 'appConfigEdit.generalData.publishOnTest',
      getProductionVersion: 'appConfigEdit.generalData.getProductionVersion',
      publishOnProduction: 'appConfigEdit.generalData.publishOnProduction',
      getTestConfirm: 'appConfigEdit.generalData.getTestConfirm',
      getProdConfirm: 'appConfigEdit.generalData.getProdConfirm',
      getTestConfirmUnsaved: 'appConfigEdit.generalData.getTestConfirmUnsaved',
      getProdConfirmUnsaved: 'appConfigEdit.generalData.getProdConfirmUnsaved',
      publishTestConfirm: 'appConfigEdit.generalData.publishTestConfirm',
      publishProdConfirm: 'appConfigEdit.generalData.publishProdConfirm',
    },
    design: {
      name: 'appConfigEdit.design.name',
      fonts: 'appConfigEdit.design.fonts',
      fontFamily: 'appConfigEdit.design.fontFamily',
      fontSize: 'appConfigEdit.design.fontSize',
      fontWeight: 'appConfigEdit.design.fontWeight',
      letterSpacing: 'appConfigEdit.design.letterSpacing',
      buttons: 'appConfigEdit.design.buttons',
      otpActionButtons: 'appConfigEdit.design.otpActionButtons',
      border: 'appConfigEdit.design.border',
      borderColor: 'appConfigEdit.design.borderColor',
      borderRadius: 'appConfigEdit.design.borderRadius',
      textAlign: 'appConfigEdit.design.textAlign',
      horizontalPosition: 'appConfigEdit.design.horizontalPosition',
      verticalPosition: 'appConfigEdit.design.verticalPosition',
      components: 'appConfigEdit.design.components',
      color: 'appConfigEdit.design.color',
      checkColor: 'appConfigEdit.design.checkColor',
      backgroundColor: 'appConfigEdit.design.backgroundColor',
      labelStyle: 'appConfigEdit.design.labelStyle',
      valueStyle: 'appConfigEdit.design.valueStyle',
      textareaHeight: 'appConfigEdit.design.textareaHeight',
      textareaMaxHeight: 'appConfigEdit.design.textareaMaxHeight',
      marginTop: 'appConfigEdit.design.marginTop',
      marginBottom: 'appConfigEdit.design.marginBottom',
      dimension: 'appConfigEdit.design.dimension',
      maxWidth: 'appConfigEdit.design.maxWidth',
      weight: 'appConfigEdit.design.weight',
      right: 'appConfigEdit.design.right',
      left: 'appConfigEdit.design.left',
      center: 'appConfigEdit.design.center',
      justify: 'appConfigEdit.design.justify',
      margins: 'appConfigEdit.design.margins',
      top: 'appConfigEdit.design.top',
      bottom: 'appConfigEdit.design.bottom',
      heading: 'appConfigEdit.design.heading',
      paragraph: 'appConfigEdit.design.paragraph',
      list: 'appConfigEdit.design.list',
      input: 'appConfigEdit.design.input',
      label: 'appConfigEdit.design.label',
      textField: 'appConfigEdit.design.textField',
      position: 'appConfigEdit.design.position',
      checkBox: 'appConfigEdit.design.checkbox',
      radio: 'appConfigEdit.design.radio',
      data: 'appConfigEdit.design.data',
      sectionSeparator: 'appConfigEdit.design.sectionSeparator',
      general: 'appConfigEdit.design.general',
      padding: 'appConfigEdit.design.padding',
      tables: 'appConfigEdit.design.tables',
      headers: 'appConfigEdit.design.headers',
      details: 'appConfigEdit.design.details',
      hover: 'appConfigEdit.design.hover',
      width: 'appConfigEdit.design.width',
      height: 'appConfigEdit.design.height',
      borderSpacing: 'appConfigEdit.design.borderSpacing',
      borderCollapse: 'appConfigEdit.design.borderCollapse',
      preview: 'appConfigEdit.design.preview',
      startColor: 'appConfigEdit.design.startColor',
      endColor: 'appConfigEdit.design.endColor',
    },
    flux: {
      newStep: 'appConfigEdit.flux.newStep',
      name: 'appConfigEdit.flux.name',
      systemSteps: 'appConfigEdit.flux.systemSteps',
      sign: 'appConfigEdit.flux.sign',
      addNewSection: 'appConfigEdit.flux.addNewSection',
      duplicateStep: 'appConfigEdit.flux.duplicateStep',
      toggleCollapse: 'appConfigEdit.flux.toggleCollapse',
      addStep: 'appConfigEdit.flux.addStep',
      listView: 'appConfigEdit.flux.listView',
      showLayoutDesigner: 'appConfigEdit.flux.showLayoutDesigner',
      hideLayoutDesigner: 'appConfigEdit.flux.hideLayoutDesigner',
      workflowView: 'appConfigEdit.flux.workflowView',
      workflowDesigner: 'appConfigEdit.flux.workflowDesigner',
      designAndManageFormFlow: 'appConfigEdit.flux.designAndManageFormFlow',
      customStep: {
        dependent: 'appConfigEdit.flux.customStep.dependent',
        dictionary: 'appConfigEdit.flux.customStep.dictionary',
        dictionaryDefaultValue:
          'appConfigEdit.flux.customStep.dictionaryDefaultValue',
        type: 'appConfigEdit.flux.customStep.type',
        text: 'appConfigEdit.flux.customStep.text',
        textLabel: 'appConfigEdit.flux.customStep.textLabel',
        textOptions: 'appConfigEdit.flux.customStep.textOptions',
        optionValue: 'appConfigEdit.flux.customStep.optionValue',
        optionLabel: 'appConfigEdit.flux.customStep.optionLabel',
        relatedDictionaries:
          'appConfigEdit.flux.customStep.relatedDictionaries',
        showDictionaryAsRadioButtonsList:
          'appConfigEdit.flux.customStep.showDictionaryAsRadioButtonsList',
        allowMultipleSelection:
          'appConfigEdit.flux.customStep.allowMultipleSelection',
        showAsCheckboxes: 'appConfigEdit.flux.customStep.showAsCheckboxes',
        relatedDictionariesTranslation:
          'appConfigEdit.flux.customStep.relatedDictionariesTranslation',
        stepDefaultValue: 'appConfigEdit.flux.customStep.stepDefaultValue',
        selectADocument: 'appConfigEdit.flux.customStep.selectADocument',
        uploadDocument: 'appConfigEdit.flux.customStep.uploadDocument',
        loadingMessage: 'appConfigEdit.flux.customStep.loadingMessage',
        noSectionMessage: 'appConfigEdit.flux.customStep.noSectionMessage',
        addSectionMessage: 'appConfigEdit.flux.customStep.addSectionMessage',
        addSectionTitle: 'appConfigEdit.flux.customStep.addSectionTitle',
        hasDependencies: 'appConfigEdit.flux.customStep.hasDependencies',
      },
      section: {
        newComponent: 'appConfigEdit.flux.section.newComponent',
        title: 'appConfigEdit.flux.section.title',
        type: 'appConfigEdit.flux.section.type',
        showSectionTitle: 'appConfigEdit.flux.section.showSectionTitle',
        showSectionSeparator: 'appConfigEdit.flux.section.showSectionSeparator',
        changeOrder: 'appConfigEdit.flux.section.changeOrder',
        addComponent: 'appConfigEdit.flux.section.addComponent',
        addSection: 'appConfigEdit.flux.section.addSection',
        edit: 'appConfigEdit.flux.section.edit',
        duplicate: 'appConfigEdit.flux.section.duplicate',
        empty: 'appConfigEdit.flux.section.empty',
        manualInput: 'appConfigEdit.flux.section.manualInput',
        manualInputText: 'appConfigEdit.flux.section.manualInputText',
        manualInputNumeric: 'appConfigEdit.flux.section.manualInputNumeric',
        manualInputDateTime: 'appConfigEdit.flux.section.manualInputDateTime',
        manualInputEmail: 'appConfigEdit.flux.section.manualInputEmail',
        manualInputPhone: 'appConfigEdit.flux.section.manualInputPhone',
        manualInputTextArea: 'appConfigEdit.flux.section.manualInputTextArea',
        paragraph: 'appConfigEdit.flux.section.paragraph',
        checkbox: 'appConfigEdit.flux.section.checkbox',
        dictionary: 'appConfigEdit.flux.section.dictionary',
        buttons: 'appConfigEdit.flux.section.buttons',
        fluxInfo: 'appConfigEdit.flux.section.fluxInfo',
        newRow: 'appConfigEdit.flux.section.newRow',
        changeSectionType: 'appConfigEdit.flux.section.changeSectionType',
        noSectionsDefined: 'appConfigEdit.flux.section.noSectionsDefined',
        dictionaryComponent:
          'appConfigEdit.flux.customStep.dictionaryComponent',
        presentationDownloadComponent:
          'appConfigEdit.flux.section.presentationDownloadComponent',
        newSection: 'appConfigEdit.flux.section.newSection',
        deleteSection: 'appConfigEdit.flux.section.deleteSection',
        duplicateSection: 'appConfigEdit.flux.section.duplicateSection',
        editSettings: 'appConfigEdit.flux.section.editSettings',
        selectSourceControl: 'appConfigEdit.flux.section.selectSourceControl',
        noSourceControlsAvailable:
          'appConfigEdit.flux.section.noSourceControlsAvailable',
        addPresentationComponent:
          'appConfigEdit.flux.section.addPresentationComponent',
        noCollectComponents: 'appConfigEdit.flux.section.noCollectComponents',
        noPresentationComponents:
          'appConfigEdit.flux.section.noPresentationComponents',
        pleaseSelectSectionType:
          'appConfigEdit.flux.section.pleaseSelectSectionType',
        selectSectionType: 'appConfigEdit.flux.section.selectSectionType',
        componentsFromPreviousSteps:
          'appConfigEdit.flux.section.componentsFromPreviousSteps',
        collectSectionTitlePrefix:
          'appConfigEdit.flux.section.collectSectionTitlePrefix',
        presentationSectionTitlePrefix:
          'appConfigEdit.flux.section.presentationSectionTitlePrefix',
        tabs: {
          general: 'appConfigEdit.flux.section.tabs.general',
          translations: 'appConfigEdit.flux.section.tabs.translations',
        },
      },
      component: {
        settings: 'appConfigEdit.flux.component.settings',
        duplicate: 'appConfigEdit.flux.component.duplicate',
        unnamed: 'appConfigEdit.flux.component.unnamed',
        referencedComponent: 'appConfigEdit.flux.component.referencedComponent',
        referencedComponentTooltip:
          'appConfigEdit.flux.component.referencedComponentTooltip',
      },
      manualInputControl: {
        controlType: 'appConfigEdit.flux.manualInputControl.controlType',
        required: 'appConfigEdit.flux.manualInputControl.required',
        labelPosition: 'appConfigEdit.flux.manualInputControl.labelPosition',
        placeholder: 'appConfigEdit.flux.manualInputControl.placeholder',
        hint: 'appConfigEdit.flux.manualInputControl.hint',
        minLength: 'appConfigEdit.flux.manualInputControl.minLength',
        maxLength: 'appConfigEdit.flux.manualInputControl.maxLength',
        pattern: 'appConfigEdit.flux.manualInputControl.pattern',
        mask: 'appConfigEdit.flux.manualInputControl.mask',
        defaultValue: 'appConfigEdit.flux.manualInputControl.defaultValue',
        step: 'appConfigEdit.flux.manualInputControl.step',
        type: 'appConfigEdit.flux.manualInputControl.type',
        options: 'appConfigEdit.flux.manualInputControl.options',
        optionsTitle: 'appConfigEdit.flux.manualInputControl.optionsTitle',
        optionValue: 'appConfigEdit.flux.manualInputControl.optionValue',
        optionLabel: 'appConfigEdit.flux.manualInputControl.optionLabel',
        addOption: 'appConfigEdit.flux.manualInputControl.addOption',
        removeOption: 'appConfigEdit.flux.manualInputControl.removeOption',
        rows: 'appConfigEdit.flux.manualInputControl.rows',
        appearance: 'appConfigEdit.flux.manualInputControl.appearance',
        alignment: 'appConfigEdit.flux.manualInputControl.alignment',
        color: 'appConfigEdit.flux.manualInputControl.color',
        buttonType: 'appConfigEdit.flux.manualInputControl.buttonType',
        addAction: 'appConfigEdit.flux.manualInputControl.addAction',
        removeAction: 'appConfigEdit.flux.manualInputControl.removeAction',
        text: 'appConfigEdit.flux.manualInputControl.text',
        tooltip: 'appConfigEdit.flux.manualInputControl.tooltip',
        actionType: 'appConfigEdit.flux.manualInputControl.actionType',
        actionValue: 'appConfigEdit.flux.manualInputControl.actionValue',
        buttonActions: 'appConfigEdit.flux.manualInputControl.buttonActions',
        actionKey: 'appConfigEdit.flux.manualInputControl.actionKey',
        action: 'appConfigEdit.flux.manualInputControl.action',
        validations: 'appConfigEdit.flux.manualInputControl.validations',
        simple: 'appConfigEdit.flux.manualInputControl.simple',
        allowedCharacters:
          'appConfigEdit.flux.manualInputControl.allowedCharacters',
        maxCharacters: 'appConfigEdit.flux.manualInputControl.maxCharacters',
        minValue: 'appConfigEdit.flux.manualInputControl.minValue',
        maxValue: 'appConfigEdit.flux.manualInputControl.maxValue',
        onlyPast: 'appConfigEdit.flux.manualInputControl.onlyPast',
        onlyFuture: 'appConfigEdit.flux.manualInputControl.onlyFuture',
        throughApi: 'appConfigEdit.flux.manualInputControl.throughApi',
        minValueShouldBe:
          'appConfigEdit.flux.manualInputControl.minValueShouldBe',
        pickApiValidationMethod:
          'appConfigEdit.flux.manualInputControl.pickApiValidationMethod',
        pickApiValidationPartner:
          'appConfigEdit.flux.manualInputControl.pickApiValidationPartner',
        precompletable: 'appConfigEdit.flux.manualInputControl.precompletable',
        selectPrecompletionField:
          'appConfigEdit.flux.manualInputControl.selectPrecompletionField',
      },
      layoutDesigner: {
        // Main UI
        layoutDesigner: 'appConfigEdit.flux.layoutDesigner.layoutDesigner',
        toggleTooltip: 'appConfigEdit.flux.layoutDesigner.toggleTooltip',
        show: 'appConfigEdit.flux.layoutDesigner.show',
        hide: 'appConfigEdit.flux.layoutDesigner.hide',
        saveLayout: 'appConfigEdit.flux.layoutDesigner.saveLayout',

        // Navigation
        steps: 'appConfigEdit.flux.layoutDesigner.steps',
        step: 'appConfigEdit.flux.layoutDesigner.step',
        sections: 'appConfigEdit.flux.layoutDesigner.sections',
        section: 'appConfigEdit.flux.layoutDesigner.section',
        components: 'appConfigEdit.flux.layoutDesigner.components',
        items: 'appConfigEdit.flux.layoutDesigner.items',
        presentation: 'appConfigEdit.flux.layoutDesigner.presentation',
        collect: 'appConfigEdit.flux.layoutDesigner.collect',

        // ViewMode
        viewMode: 'appConfigEdit.flux.layoutDesigner.viewMode',
        compact: 'appConfigEdit.flux.layoutDesigner.compact',
        detailed: 'appConfigEdit.flux.layoutDesigner.detailed',
        displayOptions: 'appConfigEdit.flux.layoutDesigner.displayOptions',
        progress: 'appConfigEdit.flux.layoutDesigner.progress',
        interaction: 'appConfigEdit.flux.layoutDesigner.interaction',
        dragAndDrop: 'appConfigEdit.flux.layoutDesigner.dragAndDrop',

        // Row management
        row: 'appConfigEdit.flux.layoutDesigner.row',
        percentUsed: 'appConfigEdit.flux.layoutDesigner.percentUsed',
        addNewRowToSection:
          'appConfigEdit.flux.layoutDesigner.addNewRowToSection',
        addNewRowAfterThis:
          'appConfigEdit.flux.layoutDesigner.addNewRowAfterThis',
        deleteRow: 'appConfigEdit.flux.layoutDesigner.deleteRow',
        addFirstRow: 'appConfigEdit.flux.layoutDesigner.addFirstRow',

        // Width controls
        width25: 'appConfigEdit.flux.layoutDesigner.width25',
        width50: 'appConfigEdit.flux.layoutDesigner.width50',
        width75: 'appConfigEdit.flux.layoutDesigner.width75',
        width100: 'appConfigEdit.flux.layoutDesigner.width100',
        auto: 'appConfigEdit.flux.layoutDesigner.auto',

        // Empty states
        newEmptyRow: 'appConfigEdit.flux.layoutDesigner.newEmptyRow',
        useAddButtonsHint:
          'appConfigEdit.flux.layoutDesigner.useAddButtonsHint',
      },
    },
    api: {
      name: 'appConfigEdit.api.name',
      sendData: 'appConfigEdit.api.sendData',
      getData: 'appConfigEdit.api.getData',
      validators: 'appConfigEdit.api.validators',
    },
    offer: {
      name: 'appConfigEdit.offer.name',
      customStep: 'appConfigEdit.offer.customStep',
      generateDocuments: 'appConfigEdit.offer.generateDocuments',
      showStepCounter: 'appConfigEdit.offer.showStepCounter',
      showStepName: 'appConfigEdit.offer.showStepName',
      showAllSteps: 'appConfigEdit.offer.showAllSteps',
      addNewSection: 'appConfigEdit.offer.addNewSection',
    },
    generatedDocuments: {
      documentsBookmarks: {
        bookmark:
          'appConfigEdit.generatedDocuments.documentsBookmarks.bookmark',
        controlName:
          'appConfigEdit.generatedDocuments.documentsBookmarks.controlName',
        bookmarkMappingValidation:
          'appConfigEdit.generatedDocuments.documentsBookmarks.mapping.validation',
      },
      addDocument: 'appConfigEdit.generatedDocuments.addDocument',
      editDocument: 'appConfigEdit.generatedDocuments.editDocument',
      name: 'appConfigEdit.generatedDocuments.name',
      label: 'appConfigEdit.generatedDocuments.label',
      generated: 'appConfigEdit.generatedDocuments.generated',
      activ: 'appConfigEdit.generatedDocuments.activ',
      version: 'appConfigEdit.generatedDocuments.version',
      validFrom: 'appConfigEdit.generatedDocuments.validFrom',
      validTo: 'appConfigEdit.generatedDocuments.validTo',
      availableBookmarks: 'appConfigEdit.generatedDocuments.availableBookmarks',
      generatedByApp: 'appConfigEdit.generatedDocuments.generatedByApp',
    },
    partners: {
      methodApi: {
        statusMethodRequirements:
          'appConfigEdit.partners.methodApi.statusMethodRequirements',
        statusMethod: 'appConfigEdit.partners.methodApi.statusMethod',
        standardInbound: 'appConfigEdit.partners.methodApi.standardInbound',
        inboundMethodType: 'appConfigEdit.partners.methodApi.inboundMethodType',
        inboundConfiguration:
          'appConfigEdit.partners.methodApi.inboundConfiguration',
        inboundAuthInfoNone:
          'appConfigEdit.partners.methodApi.inboundAuthInfoNone',
        inboundUrlStructure:
          'appConfigEdit.partners.methodApi.inboundUrlStructure',
        name: 'appConfigEdit.partners.methodApi.name',
        selectMethod: 'appConfigEdit.partners.methodApi.selectMethod',
        selectMethodType: 'appConfigEdit.partners.methodApi.selectMethodType',
        selectCallType: 'appConfigEdit.partners.methodApi.selectCallType',
        authType: 'appConfigEdit.partners.methodApi.authType',
        addHeader: 'appConfigEdit.partners.methodApi.addHeader',
        addMapping: 'appConfigEdit.partners.methodApi.addMapping',
        addApiKey: 'appConfigEdit.partners.methodApi.addApiKey',
        action: 'appConfigEdit.partners.methodApi.action',
        loadJsonContent: 'appConfigEdit.partners.methodApi.loadJsonContent',
        loadUrlContent: 'appConfigEdit.partners.methodApi.loadUrlContent',
        urlContent: 'appConfigEdit.partners.methodApi.urlContent',
        urlSegment: 'appConfigEdit.partners.methodApi.urlSegment',
        urlParameter: 'appConfigEdit.partners.methodApi.urlParameter',
        value: 'appConfigEdit.partners.methodApi.value',
        delete: 'appConfigEdit.partners.methodApi.delete',
        contentType: 'appConfigEdit.partners.methodApi.contentType',
        partnerField: 'appConfigEdit.partners.methodApi.partnerField',
        fluxField: 'appConfigEdit.partners.methodApi.fluxField',
        methodField: 'appConfigEdit.partners.methodApi.methodField',
        fieldType: 'appConfigEdit.partners.methodApi.fieldType',
      },
      dictionaryMapping: {
        name: 'appConfigEdit.partners.dictionaryMapping.name',
        loadDictionaries:
          'appConfigEdit.partners.dictionaryMapping.loadDictionaries',
        partnerValue: 'appConfigEdit.partners.dictionaryMapping.partnerValue',
        noValueFound: 'appConfigEdit.partners.dictionaryMapping.noValueFound',
      },
      documents: {
        name: 'appConfigEdit.partners.documents.name',
        add: 'appConfigEdit.partners.documents.add',
        selectMethodApi: 'appConfigEdit.partners.documents.selectMethodApi',
      },
      statuses: {
        name: 'appConfigEdit.partners.statuses.name',
        add: 'appConfigEdit.partners.statuses.addStatus',
        partnerStatus: 'appConfigEdit.partners.statuses.partnerStatus',
        appStatus: 'appConfigEdit.partners.statuses.appStatus',
        clearSelection: 'appConfigEdit.partners.statuses.clear',
      },
      generalSettings: {
        regenerateApiKey:
          'appConfigEdit.partners.generalSettings.regenerateApiKey',
        apiKeyRegenerated:
          'appConfigEdit.partners.generalSettings.apiKeyRegenerated',
        apiKeyCopied: 'appConfigEdit.partners.generalSettings.apiKeyCopied',
        apiKeyCopyError:
          'appConfigEdit.partners.generalSettings.apiKeyCopyError',
        currentApiKey: 'appConfigEdit.partners.generalSettings.currentApiKey',
        apiKeyInfo: 'appConfigEdit.partners.generalSettings.apiKeyInfo',
        apiKeyManagement:
          'appConfigEdit.partners.generalSettings.apiKeyManagement',
        addNewOffer: 'appConfigEdit.partners.generalSettings.addNewOffer',
        name: 'appConfigEdit.partners.generalSettings.name',
        apiNethod: 'appConfigEdit.partners.generalSettings.apiMethod',
        identifier: 'appConfigEdit.partners.generalSettings.identifier',
        value: 'appConfigEdit.partners.generalSettings.value',
        acceptMultipleOffers:
          'appConfigEdit.partners.generalSettings.acceptMultipleOffers',
        addNewAcceptedOffers:
          'appConfigEdit.partners.generalSettings.addNewAcceptedOffers',
        choose: 'appConfigEdit.partners.generalSettings.choose',
        valabilityPeriod:
          'appConfigEdit.partners.generalSettings.valabilityPeriod',
        hasCustomValability:
          'appConfigEdit.partners.generalSettings.hasCustomValability',
        valability: 'appConfigEdit.partners.generalSettings.valability',
        requiredApiMethodValidation:
          'appConfigEdit.partners.generalSettings.requiredApiMethodValidation',
        requiredIdentifierValidation:
          'appConfigEdit.partners.generalSettings.requiredIdentifierValidation',
        requiredValueValidation:
          'appConfigEdit.partners.generalSettings.requiredValueValidation',
        requiredMultipleOffersValidation:
          'appConfigEdit.partners.generalSettings.requiredMultipleOffersValidation',
        requiredNumberOfOffersValidation:
          'appConfigEdit.partners.generalSettings.requiredNumberOfOffersValidation',
        multipleSameOffersValidation:
          'appConfigEdit.partners.generalSettings.multipleSameOffersValidation',
      },
      name: 'appConfigEdit.partners.name',
      add: 'partners.add',
    },
    statuses: {
      name: 'appConfigEdit.statuses.name',
      order: 'appConfigEdit.statuses.order',
      final: 'appConfigEdit.statuses.final',
      active: 'appConfigEdit.statuses.active',
      addStatus: 'appConfigEdit.statuses.addStatus',
      selectStatus: 'appConfigEdit.statuses.selectStatus',
      stepName: 'appConfigEdit.statuses.stepName',
      noStatus: 'appConfigEdit.statuses.noStatusFound',
      statusUsedIn: 'appConfigEdit.statuses.statusUsedIn',
      childApplications: 'appConfigEdit.statuses.childApplications',
      sendNotifications: 'appConfigEdit.statuses.sendNotifications',
    },
    displayMode: {
      name: 'appConfigEdit.displayMode.name',
    },
    applicationListMapping: {
      name: 'appConfigEdit.applicationListMapping.name',
    },
    errors: {
      applicationHas: 'appConfigEdit.errors.applicationHas',
      applicationErrors: 'appConfigEdit.errors.applicationErrors',
    },
  };

  static readonly application = {
    api: {
      getItems: {
        name: 'application.api.getItems.name',
        fields: 'application.api.getItems.fields',
        fieldName: 'application.api.getItems.fieldName',
        fieldType: 'application.api.getItems.fieldType',
      },
      validators: {
        name: 'application.api.validators.name',
        fields: 'application.api.validators.fields',
        fieldName: 'application.api.validators.fieldName',
        fieldType: 'application.api.validators.fieldType',
        expected: 'application.api.validators.expected',
        expectedValue: 'application.api.validators.expectedValue',
      },
      sendItems: {
        name: 'application.api.sendItems.name',
      },
    },
  };

  static readonly applicationLaunch = {
    title: 'applicationLaunch.title',
    selectApplication: 'applicationLaunch.selectApplication',
    selectEnvironment: 'applicationLaunch.selectEnvironment',
    launchButton: 'applicationLaunch.launchButton',
    errorSelectApplication: 'applicationLaunch.errorSelectApplication',
    environments: {
      production: 'applicationLaunch.environments.production',
      staging: 'applicationLaunch.environments.staging',
      development: 'applicationLaunch.environments.development',
    },
  };

  static readonly stepControl = {
    title: 'stepControl.title',
    dimension: 'stepControl.dimension',
    auto: 'stepControl.auto',
    mandatory: 'stepControl.mandatory',
    translations: 'stepControl.translations',
    titleHyperlink: 'stepControl.titleHyperlink',
  };

  static readonly formly = {
    selectAnItem: 'formly.selectAnItem',
  };

  static readonly flux = {
    createStep: 'flux.createStep',
    customStep: 'flux.customStep',
    finalStep: 'flux.finalStep',
    identification: 'flux.identification',
    idScan: 'flux.idScan',
    verifyPhone: 'flux.verifyPhone',
    verifyEmail: 'flux.verifyEmail',
    sign: 'flux.sign',
    status: 'flux.status',
    pause: 'flux.pause',
    generateDocument: 'flux.generateDocument',
    downloadDocument: 'flux.downloadDocument',
    viewDocument: 'flux.viewDocument',
    action: 'flux.action',
    uploadDocument: 'flux.uploadDocument',
    viewDemo: 'flux.viewDemo',
    viewOffer: 'flux.viewOffer',
    netopia: 'flux.netopia',
    euPlatesc: 'flux.euPlatesc',
    openBanking: 'flux.openBanking',
    validation: 'flux.validation',
    omniCheckPerson: 'flux.omniCheckPerson',
    omniCheckBusiness: 'flux.omniCheckBusiness',
    presentationData: 'flux.presentationData',
    collectionData: 'flux.collectionData',
    stepInfo: {
      systemPhoneTitle: 'flux.stepInfo.systemPhoneTitle',
      systemEmailTitle: 'flux.stepInfo.systemEmailTitle',
      kycStatusTitle: 'flux.stepInfo.kycStatusTitle',
      kycPersonTitle: 'flux.stepInfo.kycPersonTitle',
      kycAddressTitle: 'flux.stepInfo.kycAddressTitle',
      kycValidationTitle: 'flux.stepInfo.kycValidationTitle',
      navigationSectionTitle: 'flux.stepInfo.navigationSectionTitle',
      systemStatusTitle: 'flux.stepInfo.systemStatusTitle',
      validationStatus: 'flux.stepInfo.validationStatus',
      fileMaxSize: 'flux.stepInfo.fileMaxSize',
      fileFormat: 'flux.stepInfo.fileFormat',
      showUploadFileButton: 'fluxt.stepInfo.showUploadFileButton',
      sources: 'flux.stepInfo.sources',
    },
    components: {
      system: {
        validEmail: 'flux.components.system.validEmail',
        validPhone: 'flux.components.system.validPhone',
      },
      sign: {
        electronic: 'flux.components.sign.electronic',
        handwritten: 'flux.components.sign.handwritten',
        qualified: 'flux.components.sign.qualified',
        automated: 'flux.components.sign.automated',
        displayDocument: 'flux.components.sign.displayDocument',
        documentList: 'flux.components.sign.documentList',
        selectDocument: 'flux.components.sign.selectDocument',
        showConfirm: 'flux.components.sign.showConfirm',
        companySign: 'flux.components.sign.companySign',
        defaultPhonePick: 'flux.components.sign.defaultPhonePick',
        firstName: 'flux.components.sign.firstName',
        lastName: 'flux.components.sign.lastName',
        grid: {
          name: 'flux.components.sign.grid.name',
          individual: 'flux.components.sign.grid.individual',
          bulk: 'flux.components.sign.grid.bulk',
        },
      },
      phone: {
        collected: 'flux.components.phone.collected',
        selectComponent: 'flux.components.phone.selectComponent',
        phoneLabel: 'flux.components.phone.phoneLabel',
        phoneButtonLabel: 'flux.components.phone.phoneButtonLabel',
        otpLabel: 'flux.components.phone.otpLabel',
        otpButtonLabel: 'flux.components.phone.otpButtonLabel',
        phoneRequiredLabel: 'flux.components.phone.phoneRequiredLabel',
        phoneErrorLabel: 'flux.components.phone.phoneErrorLabel',
        otpErrorLabel: 'flux.components.phone.otpErrorLabel',
        otpSuccessLabel: 'flux.components.phone.otpSuccessLabel',
      },
      email: {
        collected: 'flux.components.email.collected',
        selectComponent: 'flux.components.email.selectComponent',
        emailLabel: 'flux.components.email.emailLabel',
        emailButtonLabel: 'flux.components.email.emailButtonLabel',
        otpLabel: 'flux.components.email.otpLabel',
        otpButtonLabel: 'flux.components.email.otpButtonLabel',
        emailRequiredLabel: 'flux.components.email.emailRequiredLabel',
        emailErrorLabel: 'flux.components.email.emailErrorLabel',
        otpErrorLabel: 'flux.components.email.otpErrorLabel',
        otpSuccessLabel: 'flux.components.email.otpSuccessLabel',
      },
      action: {
        pickApiMethod: 'flux.components.action.pickApiMethod',
        pickApiPartners: 'flux.components.action.pickApiPartners',
      },
      listOffer: {
        addColumn: 'flux.components.viewOffer.addColumn',
        selectComponent: 'flux.components.viewOffer.selectComponent',
        name: 'flux.components.viewOffer.name',
        order: 'flux.components.viewOffer.order',
      },
    },
    viewOffers: 'flux.viewOffers',
    stepSettings: {
      title: 'flux.stepSettings.title',
      visible: 'flux.stepSettings.visible',
      general: 'flux.stepSettings.general',
      specificSettings: 'flux.stepSettings.specificSettings',
      openSpecificSettings: 'flux.stepSettings.openSpecificSettings',
      partnersSelected: 'flux.stepSettings.partnersSelected',
    },
    sectionSettings: {
      title: 'flux.sectionSettings.title',
      viewTitle: 'flux.sectionSettings.viewTitle',
      name: 'flux.sectionSettings.name',
    },
    componentSettings: {
      title: 'flux.componentSettings.title',
      name: 'flux.componentSettings.name',
      nameHint: 'flux.componentSettings.nameHint',
      label: 'flux.componentSettings.label',
      specificSettings: 'flux.componentSettings.specificSettings',
      invalidTypeLabel: 'flux.componentSettings.invalidTypeLabel',
      maxSizeLabel: 'flux.componentSettings.maxSizeLabel',
      isMandatoryLabel: 'flux.componentSettings.isMandatoryLabel',
      waitForUploadLabel: 'flux.componentSettings.waitForUploadLabel',
      failToViewLabel: 'flux.componentSettings.failToViewLabel',
      noDocumentsToShowLabel: 'flux.componentSettings.noDocumentsToShowLabel',
      simpleValidationLabel: 'flux.componentSettings.simpleValidationLabel',
      throughApiValidationLabel:
        'flux.componentSettings.throughApiValidationLabel',
      failToDownloadLabel: 'flux.componentSettings.failToDownloadLabel',
      noDocumentsToDownloadLabel:
        'flux.componentSettings.noDocumentsToDownloadLabel',
    },
    systemSteps: {
      action: {
        title: 'flux.systemSteps.action.title',
        description: 'flux.systemSteps.action.description',
        selectApiMethodLabel: 'flux.systemSteps.action.selectApiMethodLabel',
        selectApiPartnersLabel:
          'flux.systemSteps.action.selectApiPartnersLabel',
        addPartnerButton: 'flux.systemSteps.action.addPartnerButton',
        noPartnersAdded: 'flux.systemSteps.action.noPartnersAdded',
        method: 'flux.systemSteps.action.method',
        partner: 'flux.systemSteps.action.partner',
        atLeastOnePartnerRequired:
          'flux.systemSteps.action.atLeastOnePartnerRequired',
      },
      downloadDocument: {
        title: 'flux.systemSteps.downloadDocument.title',
        description: 'flux.systemSteps.downloadDocument.description',
        noDocumentsAdded: 'flux.systemSteps.downloadDocument.noDocumentsAdded',
        selectDocumentLabel:
          'flux.systemSteps.downloadDocument.selectDocumentLabel',
        documentNameLabel:
          'flux.systemSteps.downloadDocument.documentNameLabel',
        atLeastOneDocumentRequired:
          'flux.systemSteps.downloadDocument.atLeastOneDocumentRequired',
        addDocumentButton:
          'flux.systemSteps.downloadDocument.addDocumentButton',
        failToDownload: 'flux.systemSteps.downloadDocument.failToDownload',
        noDocumentsToDownload:
          'flux.systemSteps.downloadDocument.noDocumentsToDownload',
      },
      viewDocument: {
        title: 'flux.viewDocument',
        description: 'flux.viewDocument',
        noDocumentsAdded: 'flux.systemSteps.downloadDocument.noDocumentsAdded',
        selectDocumentLabel:
          'flux.systemSteps.downloadDocument.selectDocumentLabel',
        documentNameLabel:
          'flux.systemSteps.downloadDocument.documentNameLabel',
        atLeastOneDocumentRequired:
          'flux.systemSteps.downloadDocument.atLeastOneDocumentRequired',
        addDocumentButton:
          'flux.systemSteps.downloadDocument.addDocumentButton',
        failToView: 'flux.systemSteps.viewDocument.failToView',
        noDocumentsToView: 'flux.systemSteps.viewDocument.noDocumentsToView',
      },
      email: {
        title: 'flux.systemSteps.email.title',
        description: 'flux.systemSteps.email.description',
        emailLabel: 'flux.systemSteps.email.emailLabel',
        emailButtonLabel: 'flux.systemSteps.email.emailButtonLabel',
        otpLabel: 'flux.systemSteps.email.otpLabel',
        otpButtonLabel: 'flux.systemSteps.email.otpButtonLabel',
        emailErrorLabel: 'flux.systemSteps.email.emailErrorLabel',
        otpErrorLabel: 'flux.systemSteps.email.otpErrorLabel',
        otpSuccessLabel: 'flux.systemSteps.email.otpSuccessLabel',
        collected: 'flux.components.phone.collected',
        selectComponent: 'flux.components.phone.selectComponent',
      },
      euplatesc: {
        title: 'flux.systemSteps.euplatesc.title',
        description: 'flux.systemSteps.euplatesc.description',
        fieldMappingSectionTitle:
          'flux.systemSteps.euplatesc.fieldMappingSectionTitle',
        descriptionFieldLabel:
          'flux.systemSteps.euplatesc.descriptionFieldLabel',
        extraDataFieldLabel: 'flux.systemSteps.euplatesc.extraDataFieldLabel',
        emailFieldLabel: 'flux.systemSteps.euplatesc.emailFieldLabel',
        firstNameFieldLabel: 'flux.systemSteps.euplatesc.firstNameFieldLabel',
        lastNameFieldLabel: 'flux.systemSteps.euplatesc.lastNameFieldLabel',
        redirectUrlsSectionTitle:
          'flux.systemSteps.euplatesc.redirectUrlsSectionTitle',
        successUrlLabel: 'flux.systemSteps.euplatesc.successUrlLabel',
        failedUrlLabel: 'flux.systemSteps.euplatesc.failedUrlLabel',
        backToSiteUrlLabel: 'flux.systemSteps.euplatesc.backToSiteUrlLabel',
      },
      generateDocument: {
        title: 'flux.systemSteps.generateDocument.title',
        description: 'flux.systemSteps.generateDocument.description',
        noDocumentsAdded: 'flux.systemSteps.generateDocument.noDocumentsAdded',
        selectDocumentLabel:
          'flux.systemSteps.generateDocument.selectDocumentLabel',
        documentNameLabel:
          'flux.systemSteps.generateDocument.documentNameLabel',
        atLeastOneDocumentRequired:
          'flux.systemSteps.generateDocument.atLeastOneDocumentRequired',
        addDocumentButton:
          'flux.systemSteps.generateDocument.addDocumentButton',
      },
      idScan: {
        title: 'flux.systemSteps.idScan.title',
        description: 'flux.systemSteps.idScan.description',
        showUploadButtonLabel: 'flux.systemSteps.idScan.showUploadButtonLabel',
        showTakePictureButtonLabel:
          'flux.systemSteps.idScan.showTakePictureButtonLabel',
        fileFormatsLabel: 'flux.systemSteps.idScan.fileFormatsLabel',
        formatsHint: 'flux.systemSteps.idScan.formatsHint',
        maxSizeLabel: 'flux.systemSteps.idScan.maxSizeLabel',
        uploadButtonTextLabel: 'flux.systemSteps.idScan.uploadButtonTextLabel',
        takePictureButtonTextLabel:
          'flux.systemSteps.idScan.takePictureButtonTextLabel',
        oldCardLabel: 'flux.systemSteps.idScan.oldCardLabel',
        newCardLabel: 'flux.systemSteps.idScan.newCardLabel',
        oldCardHelperLabel: 'flux.systemSteps.idScan.oldCardHelperLabel',
        newCardHelperLabel: 'flux.systemSteps.idScan.newCardHelperLabel',
        uploadFrontPromptLabel:
          'flux.systemSteps.idScan.uploadFrontPromptLabel',
        uploadBackPromptLabel:
          'flux.systemSteps.idScan.uploadBackPromptLabel',
        dragDropPromptLabel: 'flux.systemSteps.idScan.dragDropPromptLabel',
        retakeLabel: 'flux.systemSteps.idScan.retakeLabel',
        usePhotoLabel: 'flux.systemSteps.idScan.usePhotoLabel',
        changeCardTypeLabel: 'flux.systemSteps.idScan.changeCardTypeLabel',
        processingMessageLabel:
          'flux.systemSteps.idScan.processingMessageLabel',
        successTitleLabel: 'flux.systemSteps.idScan.successTitleLabel',
        retryLabel: 'flux.systemSteps.idScan.retryLabel',
      },
      netopia: {
        settingsTitle: 'flux.systemSteps.netopia.settingsTitle',
        settingsDescription: 'flux.systemSteps.netopia.settingsDescription',
        fieldMappingSectionTitle:
          'flux.systemSteps.netopia.fieldMappingSectionTitle',
        emailFieldLabel: 'flux.systemSteps.netopia.emailFieldLabel',
        firstNameFieldLabel: 'flux.systemSteps.netopia.firstNameFieldLabel',
        lastNameFieldLabel: 'flux.systemSteps.netopia.lastNameFieldLabel',
        mobilePhoneFieldLabel: 'flux.systemSteps.netopia.mobilePhoneFieldLabel',
        redirectUrlsSectionTitle:
          'flux.systemSteps.netopia.redirectUrlsSectionTitle',
        redirectUrlLabel: 'flux.systemSteps.netopia.redirectUrlLabel',
        cancelUrlLabel: 'flux.systemSteps.netopia.cancelUrlLabel',
      },
      openBanking: {
        title: 'flux.systemSteps.openBanking.title',
        description: 'flux.systemSteps.openBanking.description',
        fieldMappingSectionTitle:
          'flux.systemSteps.openBanking.fieldMappingSectionTitle',
        accountNumberFieldLabel:
          'flux.systemSteps.openBanking.accountNumberFieldLabel',
        accountHolderFieldLabel:
          'flux.systemSteps.openBanking.accountHolderFieldLabel',
        emailFieldLabel: 'flux.systemSteps.openBanking.emailFieldLabel',
        bankSettingsSectionTitle:
          'flux.systemSteps.openBanking.bankSettingsSectionTitle',
        showAllBanks: 'flux.systemSteps.openBanking.showAllBanks',
        extractBankFromIBAN: 'flux.systemSteps.openBanking.extractBankFromIBAN',
        tcAcceptedByDefault: 'flux.systemSteps.openBanking.tcAcceptedByDefault',
        messages: 'flux.systemSteps.openBanking.messages',
        initialMessage: 'flux.systemSteps.openBanking.initialMessage',
        waitingMessage: 'flux.systemSteps.openBanking.waitingMessage',
        consentErrorMessage: 'flux.systemSteps.openBanking.consentErrorMessage',
        completionMessage: 'flux.systemSteps.openBanking.completionMessage',
        retryButtonLabel: 'flux.systemSteps.openBanking.retryButtonLabel',
        selectBank: 'flux.systemSteps.openBanking.selectBank',
        bank: 'flux.systemSteps.openBanking.bank',
        consentTitle: 'flux.systemSteps.openBanking.consentTitle',
        consentDescription: 'flux.systemSteps.openBanking.consentDescription',
        waitingForAuthorization:
          'flux.systemSteps.openBanking.waitingForAuthorization',
        popupWindowMessage: 'flux.systemSteps.openBanking.popupWindowMessage',
        popupBlockerMessage: 'flux.systemSteps.openBanking.popupBlockerMessage',
        accountsRetrieved: 'flux.systemSteps.openBanking.accountsRetrieved',
        transactionsRetrieved:
          'flux.systemSteps.openBanking.transactionsRetrieved',
        accountsFound: 'flux.systemSteps.openBanking.accountsFound',
        transactionsSummary: 'flux.systemSteps.openBanking.transactionsSummary',
        transactions: 'flux.systemSteps.openBanking.transactions',
      },
      pause: {
        settingsTitle: 'flux.systemSteps.pause.settingsTitle',
        settingsDescription: 'flux.systemSteps.pause.settingsDescription',
        offerReadyMessageLabel: 'flux.systemSteps.pause.offerReadyMessageLabel',
        continueOffersLinkMessageLabel:
          'flux.systemSteps.pause.continueOffersLinkMessageLabel',
        offerReadySmsMessageLabel:
          'flux.systemSteps.pause.offerReadySmsMessageLabel',
      },
      phone: {
        settingsTitle: 'flux.systemSteps.phone.settingsTitle',
        settingsDescription: 'flux.systemSteps.phone.settingsDescription',
        phoneLabel: 'flux.systemSteps.phone.phoneLabel',
        phoneButtonLabel: 'flux.systemSteps.phone.phoneButtonLabel',
        otpLabel: 'flux.systemSteps.phone.otpLabel',
        otpButtonLabel: 'flux.systemSteps.phone.otpButtonLabel',
        phoneErrorLabel: 'flux.systemSteps.phone.phoneErrorLabel',
        otpErrorLabel: 'flux.systemSteps.phone.otpErrorLabel',
        otpSuccessLabel: 'flux.systemSteps.phone.otpSuccessLabel',
        collected: 'flux.components.phone.collected',
        selectComponent: 'flux.components.phone.selectComponent',
      },
      sign: {
        title: 'flux.systemSteps.sign.title',
        description: 'flux.systemSteps.sign.description',
        signatureTypeLabel: 'flux.systemSteps.sign.signatureTypeLabel',
        electronicly: 'flux.systemSteps.sign.electronicly',
        handwritten: 'flux.systemSteps.sign.handwritten',
        qualified: 'flux.systemSteps.sign.qualified',
        qualifiedRequiresKyc: 'flux.systemSteps.sign.qualifiedRequiresKyc',
        automated: 'flux.systemSteps.sign.automated',
        documentsToSignSectionTitle:
          'flux.systemSteps.sign.documentsToSignSectionTitle',
        noDocumentsAdded: 'flux.systemSteps.sign.noDocumentsAdded',
        selectDocument: 'flux.systemSteps.sign.selectDocument',
        selectDocumentLabel: 'flux.systemSteps.sign.selectDocumentLabel',
        concatenateLabel: 'flux.systemSteps.sign.concatenateLabel',
        atLeastOneDocumentRequired:
          'flux.systemSteps.sign.atLeastOneDocumentRequired',
        addDocumentButton: 'flux.systemSteps.sign.addDocumentButton',
        outputDocumentsSectionTitle:
          'flux.systemSteps.sign.outputDocumentsSectionTitle',
        noOutputDocumentsGenerated:
          'flux.systemSteps.sign.noOutputDocumentsGenerated',
        displayDocument: 'flux.systemSteps.sign.displayDocument',
        documentList: 'flux.systemSteps.sign.documentList',
        defaultPhonePick: 'flux.systemSteps.sign.defaultPhonePick',
        firstName: 'flux.systemSteps.sign.firstName',
        lastName: 'flux.systemSteps.sign.lastName',
        grid: {
          docName: 'flux.systemSteps.sign.grid.docName',
          docVersion: 'flux.systemSteps.sign.grid.docVersion',
          outputName: 'flux.systemSteps.sign.grid.outputName',
        },
        pickFlowComponentForLastName:
          'flux.systemSteps.sign.pickFlowComponentForLastName',
        pickFlowComponentForFirstName:
          'flux.systemSteps.sign.pickFlowComponentForFirstName',
        fileNameTemplateTitle:
          'flux.systemSteps.sign.fileNameTemplateTitle',
        fileNameTemplateLabel:
          'flux.systemSteps.sign.fileNameTemplateLabel',
        fileNameTemplateDescription:
          'flux.systemSteps.sign.fileNameTemplateDescription',
        fileNameTemplateHint:
          'flux.systemSteps.sign.fileNameTemplateHint',
        insertFieldLabel:
          'flux.systemSteps.sign.insertFieldLabel',
      },
      status: {
        title: 'flux.systemSteps.status.title',
        description: 'flux.systemSteps.status.description',
        selectStatusLabel: 'flux.systemSteps.status.selectStatusLabel',
      },
      uploadDocument: {
        title: 'flux.systemSteps.uploadDocument.title',
        description: 'flux.systemSteps.uploadDocument.description',
        noDocumentsAdded: 'flux.systemSteps.uploadDocument.noDocumentsAdded',
        documentCardTitle: 'flux.systemSteps.uploadDocument.documentCardTitle',
        selectDocumentTypeLabel:
          'flux.systemSteps.uploadDocument.selectDocumentTypeLabel',
        allowedExtensionsLabel:
          'flux.systemSteps.uploadDocument.allowedExtensionsLabel',
        extensionsHint: 'flux.systemSteps.uploadDocument.extensionsHint',
        maxSizeLabel: 'flux.systemSteps.uploadDocument.maxSizeLabel',
        atLeastOneDocumentRequired:
          'flux.systemSteps.uploadDocument.atLeastOneDocumentRequired',
        addDocumentButton: 'flux.systemSteps.uploadDocument.addDocumentButton',
        invalidType: 'validatorMessages.invalidFormat',
        isMandatory: 'stepControl.mandatory',
        waitForUpload: 'flux.systemSteps.uploadDocument.waitForUpload',
      },
      viewOffer: {
        title: 'flux.systemSteps.viewOffer.title',
        description: 'flux.systemSteps.viewOffer.description',
        noOffersAdded: 'flux.systemSteps.viewOffer.noOffersAdded',
        offerNameLabel: 'flux.systemSteps.viewOffer.offerNameLabel',
        offerLinkLabel: 'flux.systemSteps.viewOffer.offerLinkLabel',
        addOfferButton: 'flux.systemSteps.viewOffer.addOfferButton',
        offerGrid: {
          name: 'flux.systemSteps.viewOffer.offerGrid.name',
          link: 'flux.systemSteps.viewOffer.offerGrid.link',
          actions: 'flux.systemSteps.viewOffer.offerGrid.actions',
        },
        atLeastOneOfferRequired:
          'flux.systemSteps.viewOffer.atLeastOneOfferRequired',
        columnName: 'flux.systemSteps.viewOffer.columnName',
        columnType: 'flux.systemSteps.viewOffer.columnType',
        addColumn: 'flux.systemSteps.viewOffer.addColumn',
      },
      validation: {
        title: 'flux.systemSteps.validation.title',
        description: 'flux.systemSteps.validation.description',
        comparisonsSection: 'flux.systemSteps.validation.comparisonsSection',
        addComparison: 'flux.systemSteps.validation.addComparison',
        leftField: 'flux.systemSteps.validation.leftField',
        operator: 'flux.systemSteps.validation.operator',
        rightField: 'flux.systemSteps.validation.rightField',
        noComparisons: 'flux.systemSteps.validation.noComparisons',
        dictionarySection: 'flux.systemSteps.validation.dictionarySection',
        selectDictionary: 'flux.systemSteps.validation.selectDictionary',
        trueResult: 'flux.systemSteps.validation.trueResult',
        falseResult: 'flux.systemSteps.validation.falseResult',
        loaderMessage: 'flux.systemSteps.validation.loaderMessage',
      },
      omniCheckPerson: {
        title: 'flux.systemSteps.omniCheckPerson.title',
        description: 'flux.systemSteps.omniCheckPerson.description',
        waitingMessage: 'flux.systemSteps.omniCheckPerson.waitingMessage',
        settings: {
          fieldMappings: 'flux.systemSteps.omniCheck.settings.fieldMappings',
          nameField: 'flux.systemSteps.omniCheck.settings.nameField',
          dateOfBirth: 'flux.systemSteps.omniCheck.settings.dateOfBirth',
          fluxField: 'flux.systemSteps.omniCheck.settings.fluxField',
          selectFluxField: 'flux.systemSteps.omniCheck.settings.selectFluxField',
          searchSettings: 'flux.systemSteps.omniCheck.settings.searchSettings',
          threshold: 'flux.systemSteps.omniCheck.settings.threshold',
          dobMatching: 'flux.systemSteps.omniCheck.settings.dobMatching',
          countries: 'flux.systemSteps.omniCheck.settings.countries',
          countriesFormatError: 'flux.systemSteps.omniCheck.settings.countriesFormatError',
          staticValue: 'flux.systemSteps.omniCheck.settings.staticValue',
          gender: 'flux.systemSteps.omniCheck.settings.gender',
          male: 'flux.systemSteps.omniCheck.settings.male',
          female: 'flux.systemSteps.omniCheck.settings.female',
          reportDocument: 'flux.systemSteps.omniCheck.settings.reportDocument',
          dictionarySection: 'flux.systemSteps.omniCheck.settings.dictionarySection',
          selectDictionary: 'flux.systemSteps.omniCheck.settings.selectDictionary',
          matchesFound: 'flux.systemSteps.omniCheck.settings.matchesFound',
          noMatches: 'flux.systemSteps.omniCheck.settings.noMatches',
          error: 'flux.systemSteps.omniCheck.settings.error',
        },
      },
      omniCheckBusiness: {
        title: 'flux.systemSteps.omniCheckBusiness.title',
        description: 'flux.systemSteps.omniCheckBusiness.description',
        waitingMessage: 'flux.systemSteps.omniCheckBusiness.waitingMessage',
        settings: {
          fieldMappings: 'flux.systemSteps.omniCheck.settings.fieldMappings',
          businessNameField: 'flux.systemSteps.omniCheck.settings.businessNameField',
          fluxField: 'flux.systemSteps.omniCheck.settings.fluxField',
          selectFluxField: 'flux.systemSteps.omniCheck.settings.selectFluxField',
          searchSettings: 'flux.systemSteps.omniCheck.settings.searchSettings',
          threshold: 'flux.systemSteps.omniCheck.settings.threshold',
          countries: 'flux.systemSteps.omniCheck.settings.countries',
          countriesFormatError: 'flux.systemSteps.omniCheck.settings.countriesFormatError',
          staticValue: 'flux.systemSteps.omniCheck.settings.staticValue',
          reportDocument: 'flux.systemSteps.omniCheck.settings.reportDocument',
          dictionarySection: 'flux.systemSteps.omniCheck.settings.dictionarySection',
          selectDictionary: 'flux.systemSteps.omniCheck.settings.selectDictionary',
          matchesFound: 'flux.systemSteps.omniCheck.settings.matchesFound',
          noMatches: 'flux.systemSteps.omniCheck.settings.noMatches',
          error: 'flux.systemSteps.omniCheck.settings.error',
        },
      },
    },
  };
}
